module.exports = __webpack_public_path__ + "bcc5e56fd346d70546e6ecc7602e1223.ttf";